(function() {
	// globals
	window.EWO.Election = window.EWO.Election || {};


	var constituencyId;

	// module functions
	EWO.Election.renderElectionEvents = function(ctx) {
		var urlQueryString = new URLSearchParams(ctx.querystring);
		var filter = Object.fromEntries(urlQueryString);
		$.extend(filter, ctx.params);

		$.when(
			ejs.preloadTemplate('/app/election/electionEvents/templates/electionEvents.ejs'),
			$.get(EWO.config.apiUrlPrefix + '/electionEvents', filter),
			$.get(EWO.config.apiUrlPrefix + '/electionevents/' + filter.electionId),
			$.get(EWO.config.apiUrlPrefix + '/municipalities/municipalitiesforelection?electionId='+ filter.electionId),
			$.get(EWO.config.apiUrlPrefix + '/elections/' + filter.electionId)
		)
		.done(function(templateUrl, list, events, municipalities, election) {
			$('.js-election-container').html(ejs.rr(templateUrl, {
				list: list[0],
				events: events,
				data: municipalities,
				filter: filter,
				election: election[0]
			}));

			//function from MD
			var setUrl = function() {
				var dtoptions = getDatatableOptions($('.sortable'));
				var newurl = refreshUrl(dtoptions);
				history.pushState({path: newurl}, '', newurl);
			};

			//function from MD
			var getDatatableOptions = function(datatable) {
				var dtoptions = {};
				if (datatable.length > 0) {
					dtoptions.order = datatable.DataTable().order();
					dtoptions.page = datatable.DataTable().page();
					dtoptions.pageLength = datatable.DataTable().page.len();
					dtoptions.lengthMenu = datatable.DataTable().lengthMenu;
				}
				return dtoptions;
			};

			//function from MD
			var refreshUrl = function(dtoptions) {
				var search = document.location.search;
				if (!$.isEmptyObject(dtoptions)) {
					var urlQueryString = new URLSearchParams(search);
					if (urlQueryString.has('dt')) {
						urlQueryString.delete('dt');
						var t = urlQueryString.toString();
						if (t) {
							search = '?' + t;
						} else {
							search = '';
						}
					}
					search = (search ? search + '&' : '?') + 'dt=' + encodeURIComponent(JSON.stringify(dtoptions));
				} else {
					search = (search ? search : '');
				}
				return document.location.pathname + search;
			};

			//datatable options
			var dtoptions = {'paging': false, 'lengthChange': false, 'info': false };
			if (urlQueryString.has('dt')) {
				dtoptions = $.extend({}, dtoptions, JSON.parse(decodeURIComponent(urlQueryString.get('dt'))));
				urlQueryString.delete('dt');
			}

			$('.sortable').DataTable(dtoptions);
			
			//save order in url
			$('.sortable').DataTable().on('order.dt', function(e, settings, ordArr) {
				setUrl();
			});

			$('[data-toggle="tooltip"]').tooltip(); 
			$('#municipalityId').select2();
			if(filter.eventId != undefined && filter.eventId != "")
			{
				$('#missing').removeAttr('disabled');
			}
			else
			{
				$('#missing').attr('disabled', 'disabled');
			}
		});

		constituencyId = filter.constituencyId;

		
	};

	EWO.Election.getCompleted = function(list){
		var totCompleted = 0;

		for (var j = 0; j < list.rows.length; j++){
			var item = list.rows[j];
			for (var k = 0; k < item.items.length; k++) {
				var element = item.items[k];
				if(element.status > 0)
				{
					totCompleted++;
				}
			}
		}

		return totCompleted;
	}


	//events
	$(document).on('submit', '.js-electionElectionEvents .js-filterform', function(ev) {
		var el = $(ev.currentTarget);
		ev.preventDefault();
		var filter = el.serialize();

		var sortOrderString = '';
		var params = window.location.search;

		if(params.includes('&dt='))
		{
			var index  = params.indexOf('&dt=');
			sortOrderString = params.substr(index);
		}

		page(document.location.pathname + (filter ? '?' + filter + sortOrderString : sortOrderString));
	});

	$(document).on('click', '.js-electionElectionEvents .js-eventRedirect', function(ev) {

		var el = $(ev.currentTarget);
			ev.preventDefault();

		var sectionNum = el.attr('data-sectionNum');
		var electionId = el.attr('data-electionId');
		var eventTypeId = el.attr('data-eventTypeId');
		var constituencyId = el.attr('data-constituencyId');
		var municipalityId = el.attr('data-municipalityId');
		var param = el.attr('data-param');

		//constitution
		if(eventTypeId != undefined && eventTypeId == 1){
			window.open('/election/'+electionId+'/constituency/'+constituencyId+'/people?&roleId=&municipalityId='+municipalityId+'&desc=&sectionNum='+sectionNum+'&sectionDesc=', '_blank');
		}

		//opening
		if(eventTypeId != undefined && eventTypeId == 2){
			window.open('/election/'+electionId+'/constituency/'+constituencyId+'/constitution?&eventTypeId=&municipalityId='+municipalityId+'&desc=&sectionNum='+sectionNum+'&sectionDesc=', '_blank');
		}

		//turnouts
		if(eventTypeId != undefined && eventTypeId == 3){
			window.open('/election/'+electionId+'/constituency/'+constituencyId+'/sectCommunications?municipalityId='+municipalityId+'&type='+param+'&sectionNum='+sectionNum+'&sectionDesc=', '_blank')
		}

		//listvotes
		if(eventTypeId != undefined && eventTypeId == 4){
			window.open('/election/'+electionId+'/constituency/'+constituencyId+'/listvotes?municipalityId='+municipalityId+'&status=&sectionNum='+sectionNum+'&sectionDesc=', '_blank')
		}

		//preferences
		if(eventTypeId != undefined && eventTypeId == 5){
			window.open('/election/'+electionId+'/constituency/'+constituencyId+'/prefvotes?municipalityId='+municipalityId+'&status=&sectionNum='+sectionNum+'&sectionDesc=', '_blank')
		}

		//major
		if(eventTypeId != undefined && eventTypeId == 6){
			window.open('/election/'+electionId+'/constituency/'+constituencyId+'/mayorvote?municipalityId='+municipalityId+'&status=&sectionNum='+sectionNum+'&sectionDesc=', '_blank')
		}

	});

	$(document).on('change', '.js-electionElectionEvents #eventId', function(ev) {
		var el = $(ev.currentTarget);
		ev.preventDefault();

		if (el.val() === undefined || el.val() === "") {
			$('#missing').attr('disabled', 'disabled');
		}
		else
		{
			$('#missing').removeAttr('disabled');
		}
	});

	// module startup

	//setup routing
	page('/election/:electionId/constituency/:constituencyId/electionEvents', window.EWO.Election.renderElectionEvents);

})();
